import * as React from 'react';
import { SvgIcon } from '@progress/kendo-react-common';

//    https://transform.tools/

export const KitIcon = () => {
  return (
    <SvgIcon className="test-icon" viewBox="0 0 128 128" size="xlarge">
      <path
        d="M105.161 31.907v55.432A8.661 8.661 0 0196.5 96a8.661 8.661 0 01-8.661-8.661V31.907z"
        fill="#dbf5ff"
      />
      <path d="M105.16 45.34v42a8.66 8.66 0 01-17.32 0v-42z" fill="#fa5ca8" />
      <path
        d="M72.661 31.907v55.432A8.661 8.661 0 0164 96a8.661 8.661 0 01-8.661-8.661V31.907z"
        fill="#dbf5ff"
      />
      <path
        d="M51.73 24h24.54v5.742a2.165 2.165 0 01-2.17 2.165H53.9a2.165 2.165 0 01-2.165-2.165V24h-.005z"
        fill="#b3ddff"
      />
      <path
        d="M40.161 31.907v55.432A8.661 8.661 0 0131.5 96a8.661 8.661 0 01-8.661-8.661V31.907z"
        fill="#dbf5ff"
      />
      <path
        d="M19.23 24h24.54v5.742a2.165 2.165 0 01-2.17 2.165H21.4a2.165 2.165 0 01-2.165-2.165V24h-.005zM84.23 24h24.54v5.742a2.165 2.165 0 01-2.165 2.165H86.4a2.165 2.165 0 01-2.165-2.165V24h-.005z"
        fill="#b3ddff"
      />
      <path
        d="M72.66 50.52v36.82a8.66 8.66 0 01-17.32 0V50.52z"
        fill="#fef002"
      />
      <path d="M40.16 45.34v42a8.66 8.66 0 01-17.32 0v-42z" fill="#6ee8c5" />
      <path fill="#59a7ff" d="M7 96H121V104H7z" />
      <g>
        <path d="M95.4 102.25h-4.5a1.75 1.75 0 000 3.5h4.5a1.75 1.75 0 100-3.5z" />
        <path d="M121 94.25h-3.876v-30.3a1.749 1.749 0 00-1.75-1.75h-8.463V33.626a3.906 3.906 0 003.608-3.884V24a1.75 1.75 0 00-1.75-1.75H84.23A1.751 1.751 0 0082.48 24v5.742a3.907 3.907 0 003.609 3.884V62.2H74.411V33.626a3.906 3.906 0 003.608-3.884V24a1.75 1.75 0 00-1.75-1.75H51.73A1.751 1.751 0 0049.98 24v5.742a3.907 3.907 0 003.609 3.884V62.2H41.911V33.626a3.906 3.906 0 003.608-3.884V24a1.75 1.75 0 00-1.75-1.75H36.2a1.75 1.75 0 000 3.5h5.817v3.992a.415.415 0 01-.415.415H21.4a.415.415 0 01-.415-.415V25.75h5.859a1.75 1.75 0 000-3.5H19.23A1.751 1.751 0 0017.48 24v5.742a3.907 3.907 0 003.609 3.884V62.2h-8.463a1.75 1.75 0 00-1.75 1.75v30.3H7A1.751 1.751 0 005.25 96v8A1.751 1.751 0 007 105.75h74.66a1.75 1.75 0 000-3.5H8.75v-4.5h110.5v4.5h-14.2a1.75 1.75 0 000 3.5H121a1.75 1.75 0 001.75-1.75v-8a1.75 1.75 0 00-1.75-1.75zm-7.376-28.55v28.55h-9.359a10.358 10.358 0 002.646-6.911V65.7zM89.589 87.339V65.7h13.822v21.639a6.911 6.911 0 01-13.822 0zm0-53.682h13.822v9.929H89.589zM85.98 25.75h21.039v3.992a.415.415 0 01-.415.415H86.4a.416.416 0 01-.415-.415zm3.609 21.336h13.822V62.2H89.589zm-3.5 18.614v21.639a10.358 10.358 0 002.646 6.911h-16.97a10.358 10.358 0 002.646-6.911V65.7zm-29 21.635V65.7h13.822v21.639a6.911 6.911 0 01-13.822 0zm0-53.682h13.822v15.121H57.089zM53.48 25.75h21.039v3.992a.415.415 0 01-.415.415H53.9a.415.415 0 01-.415-.415zm3.609 26.524h13.822V62.2H57.089zm-3.5 13.43v21.635a10.358 10.358 0 002.646 6.911h-16.97a10.358 10.358 0 002.646-6.911V65.7zm-29 21.635V65.7h13.822v21.639a6.911 6.911 0 01-13.822 0zm0-53.682h13.822v9.929H24.589zm0 13.429h13.822V62.2H24.589zM14.376 65.7h6.713v21.639a10.358 10.358 0 002.646 6.911h-9.359z" />
      </g>
    </SvgIcon>
  );
};

export const TestIcon = () => {
  return (
    <SvgIcon className="test-icon" viewBox="0 0 128 128" size="xlarge">
      <path
        d="M105.161 31.907v55.432A8.661 8.661 0 0196.5 96a8.661 8.661 0 01-8.661-8.661V31.907z"
        fill="#dbf5ff"
      />
      <path d="M105.16 45.34v42a8.66 8.66 0 01-17.32 0v-42z" fill="#fa5ca8" />
      <path
        d="M72.661 31.907v55.432A8.661 8.661 0 0164 96a8.661 8.661 0 01-8.661-8.661V31.907z"
        fill="#dbf5ff"
      />
      <path
        d="M51.73 24h24.54v5.742a2.165 2.165 0 01-2.17 2.165H53.9a2.165 2.165 0 01-2.165-2.165V24h-.005z"
        fill="#b3ddff"
      />
      <path
        d="M40.161 31.907v55.432A8.661 8.661 0 0131.5 96a8.661 8.661 0 01-8.661-8.661V31.907z"
        fill="#dbf5ff"
      />
      <path
        d="M19.23 24h24.54v5.742a2.165 2.165 0 01-2.17 2.165H21.4a2.165 2.165 0 01-2.165-2.165V24h-.005zM84.23 24h24.54v5.742a2.165 2.165 0 01-2.165 2.165H86.4a2.165 2.165 0 01-2.165-2.165V24h-.005z"
        fill="#b3ddff"
      />
      <path
        d="M72.66 50.52v36.82a8.66 8.66 0 01-17.32 0V50.52z"
        fill="#fef002"
      />
      <path d="M40.16 45.34v42a8.66 8.66 0 01-17.32 0v-42z" fill="#6ee8c5" />
      <path fill="#59a7ff" d="M7 96H121V104H7z" />
      <g>
        <path d="M95.4 102.25h-4.5a1.75 1.75 0 000 3.5h4.5a1.75 1.75 0 100-3.5z" />
        <path d="M121 94.25h-3.876v-30.3a1.749 1.749 0 00-1.75-1.75h-8.463V33.626a3.906 3.906 0 003.608-3.884V24a1.75 1.75 0 00-1.75-1.75H84.23A1.751 1.751 0 0082.48 24v5.742a3.907 3.907 0 003.609 3.884V62.2H74.411V33.626a3.906 3.906 0 003.608-3.884V24a1.75 1.75 0 00-1.75-1.75H51.73A1.751 1.751 0 0049.98 24v5.742a3.907 3.907 0 003.609 3.884V62.2H41.911V33.626a3.906 3.906 0 003.608-3.884V24a1.75 1.75 0 00-1.75-1.75H36.2a1.75 1.75 0 000 3.5h5.817v3.992a.415.415 0 01-.415.415H21.4a.415.415 0 01-.415-.415V25.75h5.859a1.75 1.75 0 000-3.5H19.23A1.751 1.751 0 0017.48 24v5.742a3.907 3.907 0 003.609 3.884V62.2h-8.463a1.75 1.75 0 00-1.75 1.75v30.3H7A1.751 1.751 0 005.25 96v8A1.751 1.751 0 007 105.75h74.66a1.75 1.75 0 000-3.5H8.75v-4.5h110.5v4.5h-14.2a1.75 1.75 0 000 3.5H121a1.75 1.75 0 001.75-1.75v-8a1.75 1.75 0 00-1.75-1.75zm-7.376-28.55v28.55h-9.359a10.358 10.358 0 002.646-6.911V65.7zM89.589 87.339V65.7h13.822v21.639a6.911 6.911 0 01-13.822 0zm0-53.682h13.822v9.929H89.589zM85.98 25.75h21.039v3.992a.415.415 0 01-.415.415H86.4a.416.416 0 01-.415-.415zm3.609 21.336h13.822V62.2H89.589zm-3.5 18.614v21.639a10.358 10.358 0 002.646 6.911h-16.97a10.358 10.358 0 002.646-6.911V65.7zm-29 21.635V65.7h13.822v21.639a6.911 6.911 0 01-13.822 0zm0-53.682h13.822v15.121H57.089zM53.48 25.75h21.039v3.992a.415.415 0 01-.415.415H53.9a.415.415 0 01-.415-.415zm3.609 26.524h13.822V62.2H57.089zm-3.5 13.43v21.635a10.358 10.358 0 002.646 6.911h-16.97a10.358 10.358 0 002.646-6.911V65.7zm-29 21.635V65.7h13.822v21.639a6.911 6.911 0 01-13.822 0zm0-53.682h13.822v9.929H24.589zm0 13.429h13.822V62.2H24.589zM14.376 65.7h6.713v21.639a10.358 10.358 0 002.646 6.911h-9.359z" />
      </g>
    </SvgIcon>
  );
};

export const StreckLogo = () => {
  return (
    <SvgIcon
      className="strecklogo"
      viewBox="0 0 444.4 87.77"
      style={{ 
        height: 40,
        width: 200
      }}
    >
      <defs>
        <style>{".cls-2{fill:#54565a}"}</style>
      </defs>
      <path
        d="M366.11 42.3a14.64 14.64 0 1121.1 13.12l13.33 15.9 6.52-8.25a23.92 23.92 0 0019.76 2.53 34 34 0 01-26.56 12.75A34.34 34.34 0 01366.7 50.4a42 42 0 01-.59-8.1m12.48-24.4a34.58 34.58 0 0121.69-7.78A33.65 33.65 0 01422 17.9c-6-.41-15.44 1.34-21.7 9.75a24.74 24.74 0 00-21.69-9.75m21.69 70.21A44.06 44.06 0 00437 68.35l-8.6-10.42a17.48 17.48 0 01-8.59 2.2 17.87 17.87 0 1117.88-17.86 18.08 18.08 0 01-4.22 11.54l6.85 8.39a42.75 42.75 0 003.88-17.91A43.33 43.33 0 00439.27 24l4.93-6.09h-8.79A44.07 44.07 0 00400.28.34c-10.54 0-25.45 4.45-35.13 17.56h-8.79l4.93 6.1c-3.4 5.72-4.93 13.37-4.93 20.24a43.88 43.88 0 0043.92 43.88"
        transform="translate(0 -.34)"
        fill="#b2292e"
      />
      <path
        className="cls-2"
        d="M419.81 53.63a11.34 11.34 0 1111.34-11.34 11.34 11.34 0 01-11.34 11.34M380.75 50.41a8.12 8.12 0 118.13-8.12 8.11 8.11 0 01-8.13 8.12M441.23 68.51v-.87h.68c.34 0 .55.15.55.42 0 .26-.21.43-.55.43zm-.53 1.41h.53V69h.57l.67 1h.63l-.74-1a.83.83 0 00.64-.83.77.77 0 00-.23-.58 1.14 1.14 0 00-.84-.3h-1.23zm1.06 1.08a2.33 2.33 0 01-2.35-2.36 2.35 2.35 0 012.36-2.37 2.32 2.32 0 012.35 2.35 2.35 2.35 0 01-2.36 2.38m0 .26a2.64 2.64 0 002.64-2.63 2.64 2.64 0 00-5.27 0 2.62 2.62 0 002.63 2.62M284 71.65h12.06V17.94H284zm-32.81.92c10.57 0 15.76-2.37 21.37-7.7l-7-9.15c-2.86 3.53-8.14 6-14 6-8.46-.06-15.89-6.52-15.89-17 0-9.94 7.43-16.76 15.89-16.73a18.2 18.2 0 0114 6l7-9.15c-5.38-4.94-10.91-7.63-20.9-7.7-16.83-.11-28.54 12.23-28.58 27.78s12 27.77 28.11 27.77m-82-.92h45.3V60.75h-33.33V50.24h29.4V39.35h-29.4V28.84h32.93v-10.9h-44.91zm-100.37 0h12.05V28.84H97v-10.9H52.72v10.9h16.09zm-46.94.77c11.82 0 20.1-6.18 20.1-16.84v-.15c0-9.36-6.6-13.63-17.83-16.12C14 37.07 12.14 34.9 12.41 32c.3-3.18 3.89-4.69 8.8-4.59a19.13 19.13 0 0112.69 4.67l6.54-8.17a31.08 31.08 0 00-20-6.74c-11.2 0-19.24 5.68-19.28 16 0 9.5 6.68 13.88 17.34 16.2 9.06 2 11.91 4 11.5 7.44S26.1 62 20.26 61.7c-6.32-.32-8.52-2-13.45-6L0 64.2a31.46 31.46 0 0021.87 8.22M108.84 17.94v53.71h12.06V28.84h15a8.08 8.08 0 018.23 8 7.54 7.54 0 01-7.75 8H124l20.49 26.86h14.95L144.7 53.9c5.62-2.23 11.8-7.08 11.82-17 0-10.34-8.58-18.9-19.45-18.89z"
        transform="translate(0 -.34)"
      />
      <path
        className="cls-2"
        d="M321.67 71.31L336.31 71.31 313.87 44.45 336.31 17.6 321.68 17.6 299.5 44.45 321.67 71.31z"
      />
    </SvgIcon>
  )
}

